import React from 'react';
import { useTranslation } from 'react-i18next';
import {BsFillExclamationTriangleFill} from "react-icons/bs";
import {MdInsertInvitation} from "react-icons/md"
import Button from '../Button';
import styles from './WarningAdminModal.module.scss'
const WarningAdminModal = ({name,lastName,updateRoleInAdmin}) => {
    const { t } = useTranslation();
    return (
        <div className={styles.wrapper}>
             <BsFillExclamationTriangleFill style={{color:'red', fontSize:'50px'}} />
<h2>{t("permissions.admin_warning", { name, lastName })}</h2>


<Button
          onPress={updateRoleInAdmin}
          svg={<MdInsertInvitation/>}
          text={t("permissions.make_admin_button", { lastName })}
          styles={"btnValidation"}
        ></Button>
        </div>
    );
};

export default WarningAdminModal;